import React from 'react';

import { imgPath } from '~common/utilities/ImgUrl';

import { getAppStore } from '../../app/AppStore';
import { Messages } from '../../codegen/Localize';
import { discardDraftRequestedAction } from '../../drafts/actions/DiscardDraftAction';
import { DraftBanner, DraftBannerAction } from '../../drafts/components/DraftBanner';
import { DraftWorkbookSpaceProps } from '../../drafts/types/DraftsTypes';
import { ISpaceItemDetailInfo } from '../../ts/models/ISpaceItemDetailInfo';
import { editWorkbookDraft } from '../actions/EditWorkbookAction';

export type WorkbookSpaceHeaderDraftBannerProps = {
  readonly draftInfo: DraftWorkbookSpaceProps;
  readonly workbookContent: ISpaceItemDetailInfo<'workbook'>;
};

export function WorkbookSpaceHeaderDraftBanner(props: WorkbookSpaceHeaderDraftBannerProps): JSX.Element {
  const handleEditDraft = () => {
    if (props.workbookContent) {
      getAppStore().dispatch(editWorkbookDraft(props.workbookContent, 'DraftBanner_ContinueEditing'));
    }
  };

  const handleDiscardDraft = () => {
    let content = props.workbookContent;
    getAppStore().dispatch(discardDraftRequestedAction({
      draftLuid: props.draftInfo.draftLuid,
      contentType: content.contentType,
      parentLuid: content.luid,
      name: content.name,
      locationOrigin: 'DraftBanner_DiscardChanges'
    }));

  };

  const draftBannerActions: DraftBannerAction[] = [];
  draftBannerActions.push({
    label: Messages.continueEditing(),
    handleAction: handleEditDraft,
    iconPath: imgPath('pencil_14px_small.svg'),
    testId: 'continue-editing'
    },
    {label: Messages.discardChanges(),
    handleAction: handleDiscardDraft,
    iconPath: imgPath('trash_14px_small.svg'),
    testId: 'discard-changes'
    });

  return (
    <DraftBanner
      lastEditDate={props.draftInfo.draftUpdatedAt}
      draftBannerActions={draftBannerActions}
      contentTypeName={Messages.lastEditedDraft()}
    />
  );
}
